export default __webpack_public_path__ + "static/media/CONTRUCCION_BANNER_RIGHT_IMG.ae2447ff.png";